import {TelegramIcon} from "@/constants/image";
import {TelegramShareButton} from "react-share";
import React from "react";
import {IShareProps} from "@components/Share/index";

const ShareTeleGram = ({url}: IShareProps) => {
  return (
    <>
      <TelegramShareButton
        url={url}
      >
        <div className='flex items-center p-3 rounded-lg cursor-pointer duration-300 hover:bg-grey-50'>
          <img src={TelegramIcon} alt='TelegramIcon' />
          <span className='ml-3 text-fs-14 text-grey-800 font-medium'>
            Chia sẻ lên Telegram
          </span>
        </div>
      </TelegramShareButton>
    </>
  )
}

export default ShareTeleGram
